import React, { useMemo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Icon, Text } from '../../../../../components';

const BranchesNavigationContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;
  background-color: var(--wash-gray-default);
  border-radius: 8px;
  padding: 4px;
  width: fit-content;
`;

const NavIcon = styled(Icon)`
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

  &:hover {
    ${({ $disabled }) => !$disabled && 'color: var(--content-body);'}
    transition: color 0.1s;
  }
`;

const BranchesLabel = styled(Text)`
  font-weight: 600;
  margin-bottom: 4px;
  letter-spacing: -0.22px;
`;

const BranchesNavigation = ({ activeBranch, branches, handleBranchChange }) => {
  const activeBranchIndex = useMemo(
    () => branches.findIndex((branch) => branch.id === activeBranch),
    [activeBranch, branches]
  );

  return (
    <BranchesNavigationContainer>
      <NavIcon
        name='chevron-left'
        displaySize={16}
        color='var(--content-subtitle)'
        $disabled={activeBranchIndex === 0}
        onClick={
          activeBranchIndex === 0
            ? undefined
            : () => handleBranchChange(branches[activeBranchIndex - 1])
        }
      />
      <BranchesLabel $small $color='var(--content-subtitle)'>
        Branch {activeBranchIndex + 1} / {branches.length}
      </BranchesLabel>
      <NavIcon
        name='chevron-right'
        displaySize={16}
        color='var(--content-subtitle)'
        $disabled={activeBranchIndex === branches.length - 1}
        onClick={
          activeBranchIndex === branches.length - 1
            ? undefined
            : () => handleBranchChange(branches[activeBranchIndex + 1])
        }
      />
    </BranchesNavigationContainer>
  );
};

BranchesNavigation.propTypes = {
  activeBranch: PropTypes.string.isRequired,
  branches: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string })).isRequired,
  handleBranchChange: PropTypes.func.isRequired
};

export { BranchesNavigation };
